import React from 'react';
import cx from 'classnames';

import { FocusPanel } from '../focus-panel/FocusPanel.view';
import SesamLink from '../common/Links/SesamLink';
import { EntityCopyConfigWarningMessage } from './EntityCopyConfigWarningMessage.view';

import { TestID } from '../../testID';

import './EntityDeletedMessage.css';

export const EntityDeletedMessage: React.FC<{
  entityId: string;
  gotoLink: string;
  isDarkMode: boolean;
  copyButton?: React.ReactNode;
  json?: string;
  entityName: 'pipe' | 'system' | 'dataset';
}> = ({ entityId, gotoLink, copyButton, isDarkMode, json, entityName }) => (
  <FocusPanel testId={TestID.EntityDeletedMessage}>
    <h2 className="entity-deleted-message-title">
      <span className="entity-name">{entityName}</span> has been deleted!
    </h2>
    <section>
      <p>
        <span className="entity-deleted-message-pre">{entityId}</span> {entityName} has been deleted
        and can no longer be edited.
        {json && <EntityCopyConfigWarningMessage />}
      </p>
      {json && (
        <>
          <h3
            className={cx('config-code-viewer-header', isDarkMode && 'dark')}
            style={{ overflow: 'hidden' }}
          >
            <span>Unsaved {entityName} Config</span>
            {copyButton}
          </h3>
          <pre
            className={cx('config-code-viewer', isDarkMode && 'dark')}
            data-testid={TestID.EntityHasDeletedConfig}
          >
            {json}
          </pre>
        </>
      )}
      <p>
        <SesamLink to={gotoLink} title="Go to the pipes list">
          Go to the {entityName}s list
        </SesamLink>
      </p>
    </section>
  </FocusPanel>
);
